document.addEventListener('DOMContentLoaded', function () {
  initSwiper();

  function initSwiper() {
    const swiperInstance = new Swiper('#collect-swiper', {
      effect: 'slide',
      autoHeight: true,
      slideClass: 'swiper-slide',
      spaceBetween: 20,
    });

    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');

    const buttons = document.querySelectorAll('.collect-type-bar button');
    let activeIndex = 0;

    buttons.forEach((btn, index) => {
      if (btn.dataset.tab === tab) {
        activeIndex = index;
      }

      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        swiperInstance.slideTo(index);

        const url = new URL(window.location);
        url.searchParams.set('tab', btn.dataset.tab);
        window.history.replaceState({}, '', url);
      });
    });

    swiperInstance.slideTo(activeIndex);
    buttons[activeIndex].classList.add('active');

    swiperInstance.on('slideChange', () => {
      const newIndex = swiperInstance.activeIndex;
      buttons.forEach((b) => b.classList.remove('active'));
      if (buttons[newIndex]) {
        buttons[newIndex].classList.add('active');

        const newTab = buttons[newIndex].dataset.tab;
        const url = new URL(window.location);
        url.searchParams.set('tab', newTab);
        window.history.replaceState({}, '', url);
      }
    });
  }
});

class CollectionProductCard extends HTMLElement {
  variants;
  current;
  btnLoading = false;
  form;
  btn;
  modalTemplate;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() { }

  init() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.add-btn');
    this.variants = JSON.parse(this.dataset.variants);
    this.current = JSON.parse(this.dataset.current);
    this.modalTemplate = this.querySelector('[data-collection-card-modal-template]');
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    this.bindFormChange(this.form, this);

    const mobileCartButton = this.querySelector('.mb_cart');
    if (this.modalTemplate && mobileCartButton) {
      mobileCartButton.addEventListener('click', () => {
        if (this.variants.length === 1) {
          if (this.btnLoading) {
            return;
          }
          this.onSubmitHandler();
        } else {
          this.showModal();
        }
      });
    }

    if (this.btn) {
      this.btn.addEventListener('click', () => {
        if (this.btnLoading) {
          return;
        }

        this.onSubmitHandler();
      });
    }
  }

  bindFormChange(form, scope) {
    if (!form || form.dataset.collectionBound === 'true') {
      return;
    }

    form.dataset.collectionBound = 'true';
    form.addEventListener('change', () => {
      const options = Array.from(
        form.querySelectorAll("input[type='radio']:checked")
      ).map((input) => input.value);

      const nextVariant = scope.variants.find(
        (variant) =>
          JSON.stringify(variant.options) === JSON.stringify(options)
      );

      if (!nextVariant) {
        return;
      }

      scope.current = nextVariant;
      scope.changeImage();
      scope.updatePrice();
    });
  }

  getGlobalModal() {
    return this.closest('[data-collection-section]')?.querySelector(
      '[data-collection-global-modal]'
    );
  }

  syncModalState(modalContent) {
    const modalImage = modalContent.querySelector('.collection-card-modal-image');
    if (modalImage && this.current?.featured_image?.src) {
      modalImage.src = this.current.featured_image.src;
      modalImage.srcset = this.current.featured_image.src;
    }

    const modalPrice = modalContent.querySelector('.price');
    if (modalPrice) {
      modalPrice.innerHTML = this.moneyWithoutTrailingZeros(this.current.price);
    }

    const modalBefore = modalContent.querySelector('.before');
    if (modalBefore) {
      const showBefore = this.current.price < this.current.compare_at_price;
      modalBefore.innerHTML = showBefore
        ? this.moneyWithoutTrailingZeros(this.current.compare_at_price)
        : '';
    }

    const selectedOptions = this.current?.options || [];
    const modalInputs = modalContent.querySelectorAll("input[type='radio']");
    modalInputs.forEach((input) => {
      input.checked = selectedOptions.includes(input.value);
    });
  }

  showModal() {
    const modal = this.getGlobalModal();
    const modalSlot = modal?.querySelector('[data-collection-modal-slot]');

    if (!modal || !modalSlot || !this.modalTemplate) {
      return;
    }

    modalSlot.innerHTML = '';
    const modalContent = this.modalTemplate.content.cloneNode(true);
    modalSlot.appendChild(modalContent);
    this.syncModalState(modalSlot);

    const modalForm = modalSlot.querySelector('form');
    this.bindFormChange(modalForm, this);

    const modalButton = modalSlot.querySelector('.add-btn');
    if (modalButton) {
      modalButton.addEventListener('click', () => {
        if (this.btnLoading) {
          return;
        }

        this.onSubmitHandler();
      });
    }

    modal.show();
  }

  changeImage() {
    const cardImage = this.querySelector('img');
    if (cardImage && this.current?.featured_image?.src) {
      cardImage.src = this.current.featured_image.src;
      cardImage.srcset = this.current.featured_image.src;
    }

    const modal = this.getGlobalModal();
    const modalImage = modal?.querySelector('.collection-card-modal-image');
    if (modalImage && this.current?.featured_image?.src) {
      modalImage.src = this.current.featured_image.src;
      modalImage.srcset = this.current.featured_image.src;
    }
  }

  updatePrice() {
    const showBefore = this.current.price < this.current.compare_at_price;
    const prices = this.querySelectorAll('.price');
    const beforePrices = this.querySelectorAll('.before');

    prices.forEach((element) => {
      element.innerHTML = this.moneyWithoutTrailingZeros(this.current.price);
    });

    beforePrices.forEach((element) => {
      element.innerHTML = showBefore
        ? this.moneyWithoutTrailingZeros(this.current.compare_at_price)
        : '';
    });

    const modal = this.getGlobalModal();
    const modalPrice = modal?.querySelector('[data-collection-modal-slot] .price');
    const modalBefore = modal?.querySelector('[data-collection-modal-slot] .before');

    if (modalPrice) {
      modalPrice.innerHTML = this.moneyWithoutTrailingZeros(this.current.price);
    }

    if (modalBefore) {
      modalBefore.innerHTML = showBefore
        ? this.moneyWithoutTrailingZeros(this.current.compare_at_price)
        : '';
    }
  }

  moneyWithoutTrailingZeros(cents, currency) {
    const money = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'JPY',
    }).format(cents / 100);
    return money.replace(/\.00$/, '');
  }

  async onSubmitHandler() {
    dataLayer.push({
      event: 'market/add',
      timestamp: new Date().toISOString(),
      isApp: USER_AGENT.isApp,
      uaMessage: USER_AGENT,
      products: [
        {
          name: this.current.name,
          id: this.current.id,
          options: this.current.options,
          num: 1,
        },
      ],
    });
    const data = {
      items: [
        {
          id: this.current.id,
          quantity: 1,
        },
      ],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };

    if (this.cart && this.cart.setActiveElement) {
      this.cart.setActiveElement(document.activeElement);
    }

    this.toggleLoading();
    await fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        if (this.variants.length !== 1) {
          this.closeModal();
        }
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            errors: response.errors || response.description,
            message: response.message,
          });
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
        this.toggleLoading();
      });
  }

  closeModal() {
    const modal = this.getGlobalModal();
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }
  }

  toggleLoading() {
    this.btnLoading = !this.btnLoading;
    this.classList.toggle('is-loading');

    if (this.btn) {
      this.btn.disabled = this.btnLoading;
    }

    const modal = this.getGlobalModal();
    if (modal) {
      modal.classList.toggle('is-loading', this.btnLoading);
    }

    const modalButton = modal?.querySelector('[data-collection-modal-slot] .add-btn');
    if (modalButton) {
      modalButton.disabled = this.btnLoading;
    }
  }
}

customElements.define('collection-product-card', CollectionProductCard);
